import { Injectable } from '@angular/core';
import { NotificationModel } from 'src/app/core/models/notification.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { AuthService } from '../../../../core/services/auth.service';
import { NotificationStatusEnum } from '../../../enums/notification-status.enum';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseService<NotificationModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'notification', authService);
  }

  // You may provide multiple ids. If so, they need to be comma-separated.
  deleteNotifications(ids: string) {
    return this.http.delete(`${this.baseUrlApi}/delete/${ids}`);
  }

  read(notification: NotificationModel) {
    return this.http.put(`${this.baseUrlApi}/read/${notification._id}`, {});
  }

  unrRead(notification: NotificationModel) {
    return this.http.put(`${this.baseUrlApi}/unRead/${notification._id}`, {});
  }

  changeMassiveReadStatus(status: NotificationStatusEnum, notificationsIds: string) {
    return this.http.put(`${this.baseUrlApi}/changeMassiveReadStatus/${notificationsIds}/${status}`, {});
  }
}
